/**
 * AdapterMethodRoute.OperationType catalog helpers.
 *
 * The full list comes from GET manage/method-routes/operation-types/.
 * Icons here are the fixed Lucide palette the backend catalog uses (legacy hero* names are aliased).
 */

import {
  lucideCircleArrowDown,
  lucideRefreshCw,
  lucideCircleArrowUp,
  lucideArrowLeftRight,
  lucideUndo2,
  lucideBanknote,
  lucideMessageSquare,
  lucideIdCard,
  lucideSearch,
  lucideCirclePlus,
} from '@ng-icons/lucide';

export interface MethodRouteOperationType {
  value: string;
  title: string;
  css: string;
  icon: string;
}

/** Register in component viewProviders so catalog icons render without per-type frontend updates. */
export const METHOD_ROUTE_OPERATION_ICONS = {
  lucideCircleArrowDown,
  lucideCircleArrowUp,
  lucideArrowLeftRight,
  lucideUndo2,
  lucideRefreshCw,
  lucideBanknote,
  lucideSearch,
  lucideIdCard,
  lucideCirclePlus,
  lucideMessageSquare,
  // Legacy Heroicons names still returned by older backends.
  heroArrowDownCircle: lucideCircleArrowDown,
  heroArrowUpCircle: lucideCircleArrowUp,
  heroArrowsRightLeft: lucideArrowLeftRight,
  heroArrowUturnLeft: lucideUndo2,
  heroArrowPath: lucideRefreshCw,
  heroBanknotes: lucideBanknote,
  heroMagnifyingGlass: lucideSearch,
  heroIdentification: lucideIdCard,
  heroPlusCircle: lucideCirclePlus,
  heroChatBubbleLeft: lucideMessageSquare,
};

export function normalizeMethodRouteOperationType(raw: Partial<MethodRouteOperationType> & { value: string }): MethodRouteOperationType {
  return {
    value: raw.value,
    title: (raw.title || raw.value).trim() || raw.value,
    css: (raw.css || 'default').trim() || 'default',
    icon: (raw.icon || '').trim(),
  };
}

export function fallbackMethodRouteOperationType(value: string): MethodRouteOperationType {
  return { value, title: value, css: 'default', icon: '' };
}

/** Map backend ChoiceEnum tokens onto chip CSS classes used in admin templates. */
export function methodRouteOpCssClass(css: string): string {
  const token = (css || 'default').toLowerCase().trim();
  if (token === 'primary') {
    return 'info';
  }
  if (token === 'secondary') {
    return 'default';
  }
  return token || 'default';
}
